import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { ViewClientWrapper } from "./styled";
import {
  BackButton,
  Box,
  SubHeadingStyled,
  ThemeLoader,
} from "../../../components/styled/Elements";
import { FormDataContainer } from "../billing/styled";
import InfoData from "../../../components/common/infoData/InfoData";
import Breadcrumbs from "../../../components/admin/Breadcrumbs/Breadcrumbs";
import ClientsApi from "../../../services/api/clientsApi";
import { PdfIcon } from "../../../components/styled/AllImages";
import { extractFileName } from "../../../utils";
const ViewClient = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [estInit, setEstInit] = useState([]);
  const [estLocation, setEstLocation] = useState([]);
  const [estContact, setEstContact] = useState([]);
  const [estUploads, setEstUploads] = useState([]);
  const [loading, setLoading] = useState(false);

  const getEditClientInfo = async () => {
    try {
      setLoading(true);
      const { data } = await ClientsApi.getClientInfo(id);

      if (data) {
        const clientInitData = [
          {
            id: 1,
            label: "type",
            text:
              parseInt(data?.client_type) === 1
                ? t("individual")
                : t("organization"),
          },
          {
            id: 2,
            label: "name_en",
            text: data?.name_en,
          },
          {
            id: 3,
            label: "name_ar",
            text: data?.name_ar,
          },
          {
            id: 4,
            label: "email",
            text: data?.email || "N/A",
          },
          {
            id: 5,
            label: "tax_registration_number",
            text: data?.tax_registration_number || "N/A",
          },
        ];
        const clientLocationData = [
          {
            id: 1,
            label: "Address",
            text: data?.address ? data?.address : "N/A",
          },
          {
            id: 2,
            label: "City",
            text: data?.city ? data?.city : "N/A",
          },
          {
            id: 3,
            label: "street_name",
            text: data?.street_name ? data?.street_name : "N/A",
          },
          {
            id: 4,
            label: "sub_number",
            text: data?.sub_number ? data?.sub_number : "N/A",
          },
          {
            id: 5,
            label: "postal_code",
            text: data?.postal_code ? data?.postal_code : "N/A",
          },
          {
            id: 6,
            label: "commercial_registration_number",
            text: data?.commercial_registration_number
              ? data?.commercial_registration_number
              : "N/A",
          },
          {
            id: 7,
            label: "building_number",
            text: data?.building_number ? data?.building_number : "N/A",
          },
          {
            id: 8,
            label: "region",
            text: data?.region ? data?.region : "N/A",
          },
        ];
        const clientContactData = [
          {
            id: 1,
            label: "fax_number",
            text: data?.fax_number || "N/A",
          },
          {
            id: 2,
            label: "phone",
            text: data?.phone || "N/A",
          },
          {
            id: 3,
            label: "mobile",
            text: data?.mobile || "N/A",
          },
        ];
        const clientUploadsData = [
          {
            id: 1,
            label: "cr",
            text: extractFileName(data?.cr) || "N/A",
            image: data?.other_document ? PdfIcon : "",
          },
          {
            id: 2,
            label: "profile",
            text: extractFileName(data?.profile) || "N/A",
            image: data?.profile ? data?.profile : "",
          },
          {
            id: 3,
            label: "contact_person_business_card",
            text: extractFileName(data?.contact_person_business_card) || "N/A",
            image: data?.contact_person_business_card
              ? data?.contact_person_business_card
              : "",
          },
          {
            id: 4,
            label: "other",
            text: extractFileName(data?.other_document) || "N/A",
            image: data?.other_document ? data?.other_document : "",
          },
        ];

        setEstInit(clientInitData);
        setEstLocation(clientLocationData);
        setEstContact(clientContactData);
        setEstUploads(clientUploadsData);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getEditClientInfo();
  }, []);

  return (
    <ViewClientWrapper>
      <Box className="content-head">
        <Box className="d-flex align-items-center flex-wrap flex-sm-nowrap gap-3 gap-md-5">
          <BackButton
            label={t("view_client")}
            onClick={() => navigate("/clients")}
          />
          <Breadcrumbs />
        </Box>
      </Box>
      {loading ? (
        <ThemeLoader />
      ) : (
        <Box className="content-container">
          <Row className="mt-3">
            <Col md={12}>
              <FormDataContainer className="dataContainer">
                {estInit?.map((view, i) => (
                  <InfoData
                    key={view.id}
                    label={view.label}
                    text={view.text}
                    render={view.render ? view.render : null}
                  />
                ))}
                <Box className="innerFoHead">
                  <SubHeadingStyled size="16px" color="var(--text)">
                    {t("location")}
                  </SubHeadingStyled>
                </Box>
                {estLocation?.map((view, i) => (
                  <InfoData
                    key={view.id}
                    label={view.label}
                    text={view.text}
                    render={view.render ? view.render : null}
                  />
                ))}
                <Box className="innerFoHead">
                  <SubHeadingStyled size="16px" color="var(--text)">
                    {t("ContactDetails")}
                  </SubHeadingStyled>
                </Box>
                {estContact?.map((view, i) => (
                  <InfoData
                    key={view.id}
                    label={view.label}
                    text={view.text}
                    render={view.render ? view.render : null}
                  />
                ))}
                <Box className="innerFoHead">
                  <SubHeadingStyled size="16px" color="var(--text)">
                    {t("Uploads")}
                  </SubHeadingStyled>
                </Box>
                {estUploads?.map((view) => (
                  <InfoData
                    key={view.id}
                    label={view.label}
                    text={view.text}
                    render={view.render ? view.render : null}
                    image={view.image}
                  />
                ))}
              </FormDataContainer>
            </Col>
          </Row>
        </Box>
      )}
    </ViewClientWrapper>
  );
};

export default ViewClient;
